import { deleteOnRuntime, enabledisableOnRuntime } from "../DisableDeleteRuntime";
import { getInstances } from "../Launch";

export function postMessageToRuntime(message) {
    window.parent.postMessage(JSON.stringify(message), process.env.REACT_APP_RUNTIME_URL);
}

export async function disableAllInstancesOfApplicationOnRuntime(context, organizationId, instances, projectName) {
    for (let instance of instances) {
        const url = projectName.replace(/[^a-zA-Z0-9\~\_\-\.]/g, "") + "_" + instance._id.slice(0, 5);
        try {
            let result = await enabledisableOnRuntime(
                context,
                "Application",
                url,
                organizationId,
                instance._id,
                null,
                true
            );

            if (result.status === undefined) {
                throw new Error(result.message);
            }
        } catch (e) {
            return ["error", e.message];
        }
    }
    return ["success", "Disabled all instances of app on runtime"];
}

export async function enableAllInstancesOfApplicationOnRuntime(context, organizationId, instances, projectName) {
    for (let instance of instances) {
        const url = projectName.replace(/[^a-zA-Z0-9\~\_\-\.]/g, "") + "_" + instance._id.slice(0, 5);
        try {
            let result = await enabledisableOnRuntime(
                context,
                "Application",
                url,
                organizationId,
                instance._id,
                null,
                false
            );

            if (result.status === undefined) {
                throw new Error(result.message);
            }
        } catch (e) {
            return ["error", e.message];
        }
    }
    return ["success", "Disabled all instances of app on runtime"];
}

export async function disableInstanceOnRuntime(context, organizationId, projectName, instanceId) {
    const url = projectName.replace(/[^a-zA-Z0-9\~\_\-\.]/g, "") + "_" + instanceId.slice(0, 5);
    try {
        let result = await enabledisableOnRuntime(
            context,
            "Application",
            url,
            organizationId,
            instanceId,
            null,
            true
        );
        if (result.status === undefined) {
            throw new Error(result.message);
        }
        return result
    } catch (e) {
        return {
            status: "error",
            message: e.message
        }
    }
}

export async function enableInstanceOnRuntime(context, organizationId, projectName, instanceId) {
    const url = projectName.replace(/[^a-zA-Z0-9\~\_\-\.]/g, "") + "_" + instanceId.slice(0, 5);
    try {
        let result = await enabledisableOnRuntime(
            context,
            "Application",
            url,
            organizationId,
            instanceId,
            null,
            false
        );

        if (result.status === undefined) {
            throw new Error(result.message);
        }
        return result
    } catch (e) {
        return {
            status: "error",
            message: e.message
        }
    }
}

export async function deleteInstanceOnRuntime(context, organizationId, projectName, instanceId) {
    const url = projectName.replace(/[^a-zA-Z0-9\~\_\-\.]/g, "") + "_" + instanceId.slice(0, 5);
    try {
        let result = await deleteOnRuntime(
            "Application",
            url,
            organizationId,
            instanceId,
            null
        );
        if (result.status === undefined) {
            throw new Error(result.message);
        }

        return result
    } catch (e) {
        return {
            status: "error",
            message: e.message
        }
    }
}